// Whether a focus is being handed back by a layer that closed, so what receives it does not treat it as a keyboard arrival.

let handingBack = 0;

/** Runs `move` (which moves the focus) with the hand-back marked; focus handlers fire synchronously inside it. */
export function handFocusBack(move: () => void): void {
    handingBack += 1;
    try {
        move();
    } finally {
        handingBack -= 1;
    }
}

export function isHandingFocusBack(): boolean {
    return handingBack > 0;
}
